import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';

import { useDisableBackButton } from '@myphx-engineering/phx-design-system';

import { Loader } from '../../components/common/Loader';
import { SimplifiedOrderConfirmation } from '../../components/order-confirmation/SimplifiedOrderConfirmation';
import { getFragment } from '../../graphql';
import { GetAnonymousPrescriberOrderDocument } from '../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../util';

export const SimplifiedOrderConfirmationRoute = () => {
    const { drxId } = useParams();

    useDisableBackButton(true);

    if (!drxId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const {
        data: anonymousPrescriberOrderData,
        loading: anonymousPrescriberOrderLoading,
        // oxlint-disable-next-line react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md
    } = useQuery(GetAnonymousPrescriberOrderDocument, {
        variables: { drxId },
        skip: !drxId,
    });

    if (anonymousPrescriberOrderLoading) {
        return <Loader />;
    }

    if (!anonymousPrescriberOrderData) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const location = getFragment(
        anonymousPrescriberOrderData?.anonymousPrescriberOrder
            ?.assignedPharmacyProvider
    );

    if (!location) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return <SimplifiedOrderConfirmation location={location} />;
};
